export const GET_MATERAILS = 'GET_MATERIALS';
export const GET_MATERAIL_INSPECTION = 'GET_MATERIAL_INSPECTION';